(function () {
  'use strict';

  var SELECTOR = '[data-nf-nav-dock]';
  var ITEM_SELECTOR = '.navmenu-depth-1 > .navmenu-item';
  var LINK_SELECTOR = '.navmenu-link-depth-1';
  var DISTANCE = 150;
  var MAX_SCALE = 0.16;
  var MAX_LIFT = 6;
  var DIRECT_LINKS = [
    { label: 'Showroom', url: '/pages/showrooms?view=nf-showrooms' },
    { label: 'Free Samples', url: '/collections/sample' }
  ];

  function handleDirectMenuClick(event) {
    if (event.button !== 0) return;
    event.stopImmediatePropagation();
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.location.assign(event.currentTarget.dataset.nfDirectUrl);
  }

  function makeMenuItemDirect(link, directUrl) {
    if (!link || !link.closest('[data-nf-nav-dock], #site-mobile-nav')) return;

    link.setAttribute('href', directUrl);
    link.setAttribute('data-href', directUrl);
    link.dataset.nfDirectUrl = directUrl;
    link.removeAttribute('onclick');
    link.removeAttribute('aria-haspopup');
    link.removeAttribute('aria-expanded');

    Array.prototype.forEach.call(
      link.querySelectorAll('.mm-arrow, .toggle-menu-btn, .navmenu-icon'),
      function (control) {
        control.setAttribute('aria-hidden', 'true');
        control.style.setProperty('display', 'none', 'important');
      }
    );

    var item = link.parentElement;
    var submenu = item && item.querySelector(':scope > .mm-submenu, :scope > .navmenu-submenu');
    if (submenu) {
      submenu.hidden = true;
      submenu.setAttribute('aria-hidden', 'true');
      submenu.style.setProperty('display', 'none', 'important');
    }

    if (link.dataset.nfDirectReady === 'true') return;
    link.dataset.nfDirectReady = 'true';
    link.addEventListener('click', handleDirectMenuClick, true);
  }

  function enforceDirectMenuItems(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    DIRECT_LINKS.forEach(function (item) {
      var selector = 'a.navmenu-link[aria-label="' + item.label + '"]';
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (link) {
        makeMenuItemDirect(link, item.url);
      });
    });
  }

  function resetLink(link) {
    link.style.removeProperty('--nf-nav-scale');
    link.style.removeProperty('--nf-nav-lift');
    link.style.removeProperty('--nf-nav-emphasis');
  }

  function setInfluence(link, influence) {
    link.style.setProperty('--nf-nav-scale', (1 + (MAX_SCALE * influence)).toFixed(3));
    link.style.setProperty('--nf-nav-lift', (-MAX_LIFT * influence).toFixed(2) + 'px');
    link.style.setProperty('--nf-nav-emphasis', Math.min(0.94, influence * 0.94).toFixed(3));
  }

  function initialiseDock(nav) {
    if (!nav || nav.dataset.nfDockReady === 'true') return;
    var rootList = nav.querySelector(':scope > .navmenu-depth-1');
    var items = rootList
      ? Array.prototype.slice.call(rootList.children).filter(function (item) {
        return item.classList.contains('navmenu-item');
      })
      : [];
    var links = items.map(function (item) { return item.querySelector(LINK_SELECTOR); }).filter(Boolean);
    if (!links.length) return;
    nav.dataset.nfDockReady = 'true';

    function reset() { links.forEach(resetLink); }
    function respondToPointer(event) {
      links.forEach(function (link) {
        var rect = link.getBoundingClientRect();
        var centre = rect.left + (rect.width / 2);
        var distance = Math.abs(event.clientX - centre);
        var influence = Math.max(0, 1 - (distance / DISTANCE));
        setInfluence(link, influence * influence * (3 - (2 * influence)));
      });
    }
    function respondToFocus(event) {
      var activeLink = event.target.closest(LINK_SELECTOR);
      if (!activeLink || !nav.contains(activeLink)) return;
      var activeIndex = links.indexOf(activeLink);
      links.forEach(function (link, index) {
        var separation = Math.abs(index - activeIndex);
        setInfluence(link, separation === 0 ? 1 : separation === 1 ? 0.38 : 0);
      });
    }

    nav.addEventListener('pointermove', respondToPointer);
    nav.addEventListener('pointerleave', reset);
    nav.addEventListener('focusin', respondToFocus);
    nav.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () { if (!nav.contains(document.activeElement)) reset(); });
    });
  }

  function initialiseAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), initialiseDock);
    enforceDirectMenuItems(root);
  }

  function start() {
    initialiseAll(document);
    if (!window.MutationObserver) return;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enforceDirectMenuItems(document);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();